
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { darkBlue } from 'app/theme'
import { getFullDateMini } from 'common/utils/DateUtil'

const SimpleTabSideList = ({
    tabs = [],
    defaultTab = '',
    onChangeTab = () => {},
    children,
    fitContent = false,
}) => {
    const [selected, setSelected] = useState(defaultTab)
    React.useEffect(() => {
        setSelected(defaultTab)
    }, [defaultTab])

    const handleSelect = (tab) => {
        setSelected(tab)
        onChangeTab(tab)
    }

    return (
        <Grid size={12} container spacing={1}>
            <Grid
                size={1}
                sx={{
                    overflow: fitContent ? 'visible' : 'scroll',
                    maxHeight: fitContent ? 'none' : '71vh',
                }}
            >

                <Stack
                    spacing={1}
                    alignItems='center'
                >
                    {tabs.map((tab) => {
                        if (tab.displayed === false) return null
                        const isCurrent = selected === tab.constant
                        return (
                            <Button
                                key={tab.constant}
                                onClick={() => handleSelect(tab.constant)}
                                disableElevation
                                variant='outlined'
                                sx={{
                                    backgroundColor: 'white',
                                    color: darkBlue,
                                    padding: '10px',
                                    borderRadius: '8px',
                                    width: '100%',
                                    boxShadow: isCurrent ? '0px 0px 5px #888' : undefined,
                                    border: isCurrent ? `2px solid ${darkBlue}` : '1px solid #e0e0e0',
                                }}
                            >
                                <Stack alignItems='center' spacing={0.4}>
                                    <Typography fontWeight='bold'>{tab.label}</Typography>
                                    {tab.date !== undefined && (
                                        <Typography>{getFullDateMini(tab.date)}</Typography>
                                    )}
                                    {tab.count !== undefined && (
                                        <Typography variant='body2' color='text.secondary'>{`${tab.count} ${tab.countLabel ?? 'ticket'}${tab.count > 1 ? 's' : ''}`}</Typography>
                                    )}
                                    {tab.bugCount !== undefined && (
                                        <Typography
                                            variant='body2'
                                            sx={{ color: tab.bugCount > 0 ? '#B10202' : 'text.secondary', fontWeight: tab.bugCount > 0 ? 'bold' : undefined }}
                                        >
                                            {`${tab.bugCount} bug${tab.bugCount > 1 ? 's' : ''} post-release`}
                                        </Typography>
                                    )}
                                </Stack>
                            </Button>
                        )
                    })}
                </Stack>
            </Grid>
            <Grid size={11} sx={{
                overflow: fitContent ? 'visible' : 'auto',
                maxHeight: fitContent ? 'none' : '72vh',
            }}
            >
                {typeof children === 'function' ? children(selected) : children}
            </Grid>
        </Grid>)
}

SimpleTabSideList.propTypes = {
    tabs: PropTypes.array,
    defaultTab: PropTypes.string,
    onChangeTab: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    fitContent: PropTypes.bool,
}

export default SimpleTabSideList
